import { useTranslate } from '@tolgee/react';
import { SupplementKnowledgeDetailResponse } from 'services/api/supplementKnowledge';
import dayjs from 'lib/dayjs';
import { ReactComponent as CustomerIcon } from 'views/Knowledge/assets/customer.svg';
import { ReactComponent as CalendarIcon } from 'views/Knowledge/assets/calendar.svg';
import Icon from '@ant-design/icons';

export const SupplementKnowledgeSidebarHeader = (props: {
  dataSource: SupplementKnowledgeDetailResponse;
}) => {
  const { dataSource } = props;
  const { t } = useTranslate();
  const {
    supplementalKnowledgeValue: { buyerNick },
    storeInfo,
    submittedUserName,
    submittedTime,
  } = dataSource;
  const { storeName } = storeInfo || {};
  return (
    <div className="w-full flex items-center gap-4 px-4">
      <div className="flex flex-col">
        <div className="flex items-center gap-1 h-[32px]">
          <Icon component={CustomerIcon} />
          <span>
            {t('提交人')}:{submittedUserName}
          </span>
        </div>
        <div className="flex items-center gap-1 h-[32px]">
          <Icon component={CalendarIcon} />
          <span>
            {t('买家昵称')}:{buyerNick}
          </span>
        </div>
      </div>
      <div className="flex flex-col">
        <div className="flex items-center gap-1 h-[32px]">
          <Icon component={CustomerIcon} />
          <span>
            {t('feedback.提交时间')}:{dayjs(submittedTime).format('YYYY-MM-DD HH:mm:ss')}
          </span>
        </div>
        <div className="flex items-center gap-1 h-[32px]">
          <Icon component={CalendarIcon} />
          <span>
            {t('店铺名称')}: {storeName}
          </span>
        </div>
      </div>
    </div>
  );
};
